export const HosMainTranslationsDictionary = {
    // Main view
    HOS: "HOS",
    Status: "Status",
    Logs: "Logs",
    TimeRemaining: "Time Remaining",
    ViewCycleRecap: "View cycle recap",
    HideCycleRecap: "Hide cycle recap",
    ViewExemptions: "View exemptions",
    HideExemptions: "Hide exemptions",

    // Ruleset
    StartOfDay: "Start of day",
    ChangeRuleset: "Change ruleset",
    RulesetChangedSuccessfully: "Ruleset changed successfully",
    SplitSleeper: "Split sleeper",
    Recent: "Recent",
    OtherRulesets: "Other rulesets",
    HideAll: "Hide all",
    ShowAll: "Show all",
    CannotSwitchRulesetUntilCycleReset: "You cannot switch to this ruleset until you complete a cycle reset for the previous {0} ruleset.",
    ExemptionAnnotationRequired: "Exemption annotation required - feature not yet implemented",
    StartOfDaySelectionRequired: "Start of day selection required - feature not yet implemented",

    // Cycle Recap
    CycleRecap: "Cycle Recap",
    CycleAvailableTomorrow: "Cycle Available Tomorrow",
    Total: "Total",

    // Exemptions
    Exemptions: "Exemptions",
    AdverseDrivingConditions: "Adverse Driving Conditions",
    ContactAdminToEnable: "Contact your company Administrator to enable.",
    InEffectUntilNextShiftReset: "In effect until next shift reset or sleeper split.",
    CannotApplyBeforeStartingWorkShift: "Cannot apply before starting a work shift.",
    Disabled: "Disabled",
    Enabled: "Enabled",
    Apply: "Apply",
    Remove: "Remove",
    SixteenHourExemption: "16-hour Exemption",
    ApplyToday: "Apply today",
    OffDutyDeferral: "Off-duty Deferral",
    DeferralUnavailableWhileSplitting: "Deferral unavailable while splitting off-duty time.",
    YardMove: "Yard Move",
    YardMoveLowerCase: "yard move",
    CannotStartWhileInPersonalConveyance: "Cannot start while in Personal Conveyance.",
    Start: "Start",
    Stop: "Stop",
    PersonalConveyance: "Personal Conveyance",
    PersonalConveyanceLowerCase: "personal conveyance",
    CannotStartWhileInYardMove: "Cannot start while in Yard Move.",
    OilWellWaitTime: "Oil Well Wait Time",
    AlbertaReducedRest: "Alberta Reduced Rest",
    AlbertaReducedRestDescription: "Apply during or after the period of reduced rest. You can use this exemption once every 7 days. Exemption not available while in violation.",
    WorkExemption: "Work Exemption",
    RailroadExemption: "Railroad Exemption",
    ReducedRestExemption: "Reduced Rest Exemption",
    CurrentSituationMessage: "You are currently under the {0} exemption.",
    UsingPcWhileExempt: "Using PC while using Exempt HOS, {0}: {1}.",

    // Status labels (OFF, SB, D, ON are typically not translated, but included for completeness)
    OFF: "OFF",
    SB: "SB",
    D: "D",
    ON: "ON",

    // Time units
    Hours: "h",
    Minutes: "m",
    MinutesTemplate: "{minutes}m",
    DaysTemplate: "{0} days",
    TimeLeftTemplate: "{0} left",

    // Break messages
    BreakDuration: "{0} Break duration",
    Break: "{0} Break",
    BreakRequiredIn: "{0} Break required in",

    // Status messages
    Driving: "Driving",
    OnDuty: "On Duty",
    OffDuty: "Off Duty",
    InSleeperBerth: "in Sleeper Berth",
    CurrentlyWorking: "Currently working",
    CurrentlyResting: "Currently resting",

    // Workflow messages
    PendingStatusMessage: "{Work status} will begin at {date}. You cannot change status again until {Shift date}.",
    ExcludesIgnoredLogs: "Excludes {0} ignored logs ({time}) which will still appear on Roadside Checks.",
    PressToContinueOrEnd: "Press to continue or end your {0} status",

    // Personal Conveyance messages
    MaxPCLimitExceeded: "Maximum daily personal conveyance limit of {0} exceeded.",
    MaxPCLimitMessage: "The maximum daily personal conveyance limit is {0}.",
    PCDescription: "You can drive your truck off-duty when relieved from work duties.",
    PCIgnitionCyclingMessage: "Note: Your PC Status doesn't end when the ignition is off. When you restart the vehicle, you must continue or end the status, or your status will switch to driving.",

    // Workday messages
    StartDay: "Start day",
    EndDay: "End day",
    Continue: "Continue",

    // Log messages
    LogExistsWaitFutureElapsed: "A log with status {0} already exists at {1}. Please wait until the future log has elapsed at least 15 minutes to enter {2}.",
    LogExistsWaitActive: "A log with status {0} already exists at {1}. Please wait until the future log is active to enter {2}.",
    LogExistsWaitCurrentElapsed: "A log with status {0} already exists at {1}. Please wait until the current log has elapsed at least 15 minutes to enter {2}.",
    ChangeTimeOrAnnotate: "Change time or annotate",

    // Exemption messages
    ExemptionEnded: "Exemption ended",
    ExemptionApplied: "Exemption applied",
    SixteenHourExemptionUsage: "The number of times the 16-hour exemption can be used: {0}. This can be used every {1} days and is not extended by split sleeper breaks.",
    SixteenHourExemptionApplied: "16h exemption is applied at {0}",
    WaitTimeApplied: "Wait time applied at {0}.",
    ConfirmEndExemption: "Are you sure you want to end the exemption? Any further driving will create {0} status records.",
    ConfirmApplyExemption: "Are you sure you want to apply the {0} exemption?",
    DutyStatusWillBeSet: "Your duty status will be set to {0} for the duration of this exemption.",
    ExemptionCompletelyExempts: "This relieves you from driving hour rules for today. It ends automatically with your workday, or you may end it earlier.",
    PleaseDescribeReason: "Please describe the reason:",
    AnnotationRequired: "An annotation is required:",
    ReasonForExemption: "Enter reason for exemption:",
    Optional: "Optional:",

    // Adverse Driving Conditions
    // eslint-disable-next-line max-len
    AdverseDrivingAcknowledgement: "This exemption applies to weather hazards (snow, ice, sleet, fog, or other bad weather) and unusual road conditions. These conditions were unforeseeable at the start of your shift, after your last break, or to your carrier before dispatch.",
    AdverseDrivingApplied: "Adverse driving conditions applied at {0}",

    // Railroad Exemption
    RailroadExemptionApplied: "Railroad exemption applied at {0}.",

    // Reduced Rest Exemption
    AddReductionToNextReset: "Add any reduction in rest to your next shift reset.",
    AdditionalOffDutyHoursRequired: "Number of additional off-duty hours you are required to take for your next shift reset: {0}",

    // Deferral messages
    DayOne: "Day one",
    DayTwo: "Day two",
    OffDutyDeferred: "Off-duty deferred: {0}",

    // Status change messages
    UserIsNowStatus: "{0} is now {1}",
    UserIsNowStatusAtTime: "{0} is now {1} at {2}."
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in HosMainTranslationsDictionary) {
        r.push(HosMainTranslationsDictionary[prop]);
    }
    return r;
};

export const HosMainTranslations = getTranslations();
